import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';
import Button from '../button';

interface PaginationProps {
  itemsPerPage: number;
  totalItems: number;
  paginate: (pageNumber: number) => void;
  currentPage: number;
}

const Pagination: React.FC<PaginationProps> = ({ itemsPerPage, totalItems, paginate, currentPage }) => {
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }
  // Check if there are more items to load
  const hasMore = currentPage < Math.ceil(totalItems / itemsPerPage);

  return (
    <div className="mt-5 cursor-pointer">
      {/* Mobile - Show More Button */}
      {/* <div className="lg:hidden flex justify-center">
        {hasMore && (
          <Button
            onClick={() => paginate(currentPage + 1)}
            className="w-full border border-[#2B2C39] text-white !bg-[#2B2C39] px-9 py-3 text-16 font-medium"
          >
            Show More
          </Button>
        )}
      </div> */}

      {/* Desktop - Full Pagination */}
      <nav className="hidden lg:block">
        <ul className="flex justify-center md:justify-end">
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button
              onClick={() => paginate(currentPage - 1)}
              className="border border-[#DDDDDD] px-3 py-3 text-14 text-[#808080]"
              disabled={currentPage === 1}
            >
              <ChevronLeftIcon width={20} />
            </button>
          </li>
          {pageNumbers?.length <= 10 ? (
            pageNumbers.map((number) => (
              <li
                onClick={() => paginate(number)}
                key={number}
                className={`border border-[#DDDDDD] px-4 py-2 text-[#808080] ${currentPage === number ? 'border !border-[#2B2C39] bg-[#DDDDDD] px-4 py-2 !text-[#174F1C]' : ' '
                  }`}
              >
                <button className="w-full h-full">
                  {number}
                </button>
              </li>
            ))
          ) : (
            <>
              {pageNumbers.slice(currentPage <= 9 ? 0 : currentPage - 9, currentPage <= 9 ? 9 : currentPage).map((number) => (
                <li
                  onClick={() => paginate(number)}
                  key={number}
                  className={`border border-[#DDDDDD] px-4 py-2 text-[#808080] ${currentPage === number ? 'border !border-[#2B2C39] bg-[#DDDDDD] px-4 py-2 !text-[#174F1C]' : ' '
                    }`}
                >
                  <button className="w-full h-full">
                    {number}
                  </button>
                </li>
              ))}
              {currentPage !== pageNumbers.at(-1) && <span className="mx-1 flex items-end"> ... </span>}
              {/* {pageNumbers.slice(pageNumbers.at(-4), pageNumbers.at(-1)).map((number) => (
                <li
                  onClick={() => paginate(number)}
                  key={number}
                  className={`border border-[#DDDDDD] px-4 py-2 text-[#808080] ${currentPage === number ? 'border !border-[#2B2C39] bg-[#DDDDDD] px-4 py-2 !text-[#174F1C]' : ' '
                    }`}
                >
                  <button className="w-full h-full">
                    {number}
                  </button>
                </li>
              ))} */}
            </>
          )}
          <li className={`page-item ${currentPage === Math.ceil(totalItems / itemsPerPage) ? 'disabled' : ''}`}>
            <button
              onClick={() => paginate(currentPage + 1)}
              className="border border-[#DDDDDD] px-3 py-3 text-14 text-[#808080]"
              disabled={currentPage === Math.ceil(totalItems / itemsPerPage)}
            >
              <ChevronRightIcon width={20} />
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
